import React, { useState, useEffect } from 'react'
import {
  fetchOrdersToCollect,
  confirmCustomerArrival,
} from '../core/httpService'
import { useStoreFinderHook } from '../core/customHooks'
import Home from '../pages/Home'
import ErrorCard from '../components/ErrorCard'
import Loader from '../components/utils/Loader'
import StoreInfo from '../components/store/StoreInfo'
import FAQLink from '../components/FAQLink'

const HomeContainer = ({ match }) => {
  const [isLoading, setLoading] = useState(true)
  const [orderData, setOrderData] = useState()
  const [apiCallError, setApiCallError] = useState('')
  const [showStoreDetails, setShowStoreDetails] = useState(false)

  const orderId = match.params.orderId

  useEffect(() => {
    async function fetchData() {
      if (orderId) {
        setLoading(true)
        try {
          const res = await fetchOrdersToCollect(orderId)
          setLoading(false)
          setOrderData(res)
        } catch (error) {
          setLoading(false)
          setApiCallError(error)
        }
      } else {
        setLoading(false)
        setApiCallError('Invalid Order Id')
      }
    }
    fetchData()
  }, [orderId])

  const retailerSiteId =
    orderData && orderData.length ? orderData[0].retailerSiteId : undefined
  const storeData = useStoreFinderHook(retailerSiteId)

  async function handleArrivalConfirmation(bayId, order) {
    const { orderId, retailerSiteId } = order
    try {
      await confirmCustomerArrival({
        orderId,
        retailerSiteId,
        collectLocation: bayId,
      })
      return
    } catch (error) {
      setApiCallError(error)
      throw error
    }
  }

  return (
    <>
      {isLoading && <Loader className="text-tertiary" />}
      {apiCallError ? (
        <ErrorCard />
      ) : (
        orderData && (
          <>
            <Home
              orderId={orderId}
              orderData={orderData}
              onArrivalConfirmation={handleArrivalConfirmation}
            />
            {storeData && (
              <>
                <FAQLink storeData={storeData} href="/collect/faq" />
                <StoreInfo
                  storeData={storeData}
                  showStoreDetails={showStoreDetails}
                  onStoreDetailsClick={showDetails =>
                    setShowStoreDetails(showDetails)
                  }
                />
              </>
            )}
          </>
        )
      )}
    </>
  )
}

export default HomeContainer
